module.exports = __webpack_public_path__ + "static/media/spaceships_alt.b712cf78.svg";